module.exports = __webpack_public_path__ + "static/media/mission.3ae81029.jpg";